var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { CertificatesEditorView } from "./certificatesEditorView";
import { useForm } from "react-hook-form";
export var CertificatesEditorAFY = function (_a) {
    var _b = _a.onSaveData, onSaveData = _b === void 0 ? function () { } : _b, _c = _a.onCancelButton, onCancelButton = _c === void 0 ? function () { } : _c, _d = _a.onCloseDrawer, onCloseDrawer = _d === void 0 ? function () { } : _d, _e = _a.onOpenDrawer, onOpenDrawer = _e === void 0 ? function () { } : _e, props = __rest(_a, ["onSaveData", "onCancelButton", "onCloseDrawer", "onOpenDrawer"]);
    var _f = useState(false), isLayoutReady = _f[0], setIsLayoutReady = _f[1];
    var _g = useState(props.mergeFieldsData), dataMergeFieldsSb = _g[0], setDataMergeFieldsSb = _g[1];
    var _h = useState(""), initialValue = _h[0], setInitialValue = _h[1];
    var _j = useState(props.openDrawer), openDrawerSb = _j[0], setOpenDrawerSb = _j[1];
    var _k = useForm({
        mode: "onChange",
    }), register = _k.register, control = _k.control, _l = _k.formState, errors = _l.errors, isValid = _l.isValid, setValue = _k.setValue, getValues = _k.getValues, setError = _k.setError, clearErrors = _k.clearErrors, trigger = _k.trigger;
    useEffect(function () {
        setIsLayoutReady(true);
        return function () { return setIsLayoutReady(false); };
    }, []);
    useEffect(function () {
        setInitialValue(props.initialData || "");
    }, [props.initialData]);
    useEffect(function () {
        setOpenDrawerSb(props.openDrawer);
    }, [props.openDrawer]);
    useEffect(function () {
        setDataMergeFieldsSb(props.mergeFieldsData);
    }, [props.mergeFieldsData]);
    useEffect(function () {
        if (props.dataForm) {
            for (var key in props.dataForm) {
                // @ts-ignore
                setValue(key, props.dataForm[key]);
            }
            if (Object.keys(props.dataForm).length > 0) {
                trigger();
            }
        }
    }, [props.dataForm]);
    return (_jsx(CertificatesEditorView, { productTitle: props.productTitle, productTitleColor: props.productTitleColor, productName: props.productName, productNameColor: props.productNameColor, titleCancelButton: props.titleCancelButton, onCancelButton: onCancelButton, titleNextButton: props.titleNextButton, onSaveData: onSaveData, dataMergeFieldsSb: dataMergeFieldsSb, isLayoutReady: isLayoutReady, heightGrid: props.heightGrid, language: props.language, initialValue: initialValue, licenseKey: props.licenseKey, placeholder: props.placeholder, labelFileName: props.labelFileName, 
        //
        openDrawerSb: openDrawerSb, onOpenDrawer: onOpenDrawer, onCloseDrawer: onCloseDrawer, descriptionDrawer: props.descriptionDrawer, titleSaveButton: props.titleSaveButton, labelTypeCertificate: props.labelTypeCertificate, TypeListDrawer: props.TypeListDrawer, register: register, errors: errors, setError: setError, clearErrors: clearErrors, control: control, isValid: isValid, getValues: getValues, dataForm: props.dataForm, errorTextFileName: props.errorTextFileName, errorTextTypeFile: props.errorTextTypeFile }));
};
